module.exports = __webpack_public_path__ + "img/navmenu-expand-btn.73165b53.svg";